import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { getLocalStorage, setLocalStorage } from '@helpers/local_storage';
import LabelTree from './label_tree';
import ToggleDrawerButton from './toggle_drawer_button';
import './styles/main';

const LabelsDrawer = (props) => {
  const [expandedLabels, setExpandedLabels] = useState({});

  const {
    activateLabel,
    activeLabelKey,
    labels,
    filtersDrawerOpen,
    selectedAssetKeys,
    toggleFiltersDrawer
  } = props;
  const resourceName = BF.fx.resource().name;
  const activeClass = activeLabelKey ? '' : 'active';
  const labelsDrawerClass = filtersDrawerOpen === 'labels' ? 'open' : '';

  const setPreviousLabels = () => {
    const labelsDrawerOpenLocal = getLocalStorage('labelsDrawerOpen') === 'true';
    const expandedLabelsLocal = JSON.parse(getLocalStorage('expandedLabels'));

    if (labelsDrawerOpenLocal) {
      toggleFiltersDrawer('labels-drawer');

      if (expandedLabelsLocal && Object.keys(expandedLabelsLocal).length) {
        setExpandedLabels(expandedLabelsLocal);
      }
    }
  };

  const toggleExpand = (key, removeExistingKey = true, toggleState) => {
    const updatedExpandedLabels = { ...expandedLabels };

    if (updatedExpandedLabels[key] && removeExistingKey && !toggleState) {
      delete updatedExpandedLabels[key];
    } else if (!updatedExpandedLabels[key]) {
      updatedExpandedLabels[key] = true;
    }

    setLocalStorage('expandedLabels', JSON.stringify(updatedExpandedLabels));
    setExpandedLabels(updatedExpandedLabels);
  };

  const toggleExpandForActiveLabel = (key) => {
    const activeLabelPath = [...labels.labelsFlat[key].path];

    if (activeLabelPath.length > 1) {
      activeLabelPath.pop(); // remove key for activeLabel so only parents are expanded
      activeLabelPath.forEach((labelKey) => { toggleExpand(labelKey, false); });
    }
  };

  useEffect(() => {
    setPreviousLabels();
  }, []);

  useEffect(() => {
    if (activeLabelKey) {
      toggleExpandForActiveLabel(activeLabelKey);
    }
  }, [activeLabelKey]);

  const onLabelSelect = (key) => {
    if (key === activeLabelKey) { return undefined; }

    const newKey = key === 'resource' ? null : key;
    activateLabel(newKey);
    return undefined;
  };

  return (
    <section className={`labels-drawer-container ${labelsDrawerClass}`}>
      <div className={`labels-drawer-container-maxheight ${selectedAssetKeys.size ? 'select-bar-active' : ''}`}>
        <div className="labels-toggle-tab">
          <ToggleDrawerButton toggleFiltersDrawer={toggleFiltersDrawer}>
            <p className="drawer-title">{t('LABELS')}</p>
          </ToggleDrawerButton>
        </div>
        <div className="labels-expand-container">
          <p className="drawer-title">{t('LABELS')}</p>
          <ToggleDrawerButton toggleFiltersDrawer={toggleFiltersDrawer} />
        </div>
        <div className={`label-item ${activeClass}`}>
          <div className="label-name-container">
            <button
              className="select-button"
              onClick={() => onLabelSelect('resource')}
              type="button"
            >
              <h4 className="name-copy">{resourceName}</h4>
            </button>
          </div>
        </div>
        <LabelTree
          activeLabelKey={activeLabelKey}
          expandedLabels={expandedLabels}
          labelsTree={labels.labelsTree}
          onLabelSelect={onLabelSelect}
          toggleExpand={toggleExpand}
        />
      </div>
    </section>
  );
};

LabelsDrawer.propTypes = {
  activateLabel: PropTypes.func.isRequired,
  activeLabelKey: PropTypes.string,
  labels: PropTypes.shape({}),
  filtersDrawerOpen: PropTypes.oneOf(['labels', 'advanced-filters', 'none']).isRequired,
  selectedAssetKeys: PropTypes.instanceOf(Set).isRequired,
  toggleFiltersDrawer: PropTypes.func.isRequired,
};

LabelsDrawer.defaultProps = {
  activeLabelKey: null,
  labels: {},
};

export default LabelsDrawer;
